import type {
    PersonalizationFields,
    PersonalizeFormInputsDictionary,
    PersonalizedProduct,
} from '@app/pdp/components/PersonalizedProduct/types';
import type { MappedProductVariant } from '@libs/algolia';

import { inputsBuilder } from './inputsBuilder';

export const personalizedProductMapper = (
    product: MappedProductVariant
): PersonalizedProduct => {
    const isPersonalized = !!product.personalization?.templateId;

    const personalizationInputs: PersonalizeFormInputsDictionary = {};

    personalizationInputs.front = inputsBuilder(
        product.personalization?.textLocations?.frontLines,
        product.isCustomizationMandatory
    );
    personalizationInputs.back = inputsBuilder(
        product.personalization?.textLocations?.backLines,
        product.isCustomizationMandatory
    );

    const personalizationFields: PersonalizationFields = {
        templateId: product.personalization?.templateId ?? 0,
        customizationType: product.personalization?.customizationType ?? '',
    };

    return {
        isPersonalized,
        personalizationFields,
        personalizationInputs,
    };
};
